(function () {
    "use strict";

    var formatterRegex = /\B(?=(\d{3})+(?!\d))/g;
    String.prototype.toCommaThousands = function () {
        return (parseInt(this) || 0).toString().replace(formatterRegex, ",");
    };
    Number.prototype.toCommaThousands = function () {
        return this.toString().replace(formatterRegex, ",");
    };
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/Object.toCommaThousands.js